<template>
  <div class="content no-center"> 
    <h1>Kære Virksomheder</h1>
    <h3>
Støt op om udvikling af unges digitale kompetencer <br>
- Vær med til at tilbyde Odenses 6.klasser 2-3 timers virksomhedsbesøg!</h3>

<p>Gennem Coding Class lærer 6. klasseselever i hele Odense at kode computerspil i blokprogrammering. <br>
    Projektet er udviklet af ITBranchen og køres nu af Børn &amp; Unge Forvaltningen, Børnene i Robotbyen og UngOdense. <br> 
    For femte år i træk afvikles det af Computer Clubhouse, Ungdomshuset, der kommer ud på skolerne i fire hele dage, og hjælper eleverne med at lave deres spil. <br>
Herefter skal spillene præsenteres for en virksomhed, og det er her I kommer ind i billedet. <br>
Vi ved fra foregående år, at virksomhedsbesøget er en kæmpe motivator for eleverne. <br> 
De får et vigtigt indblik i, hvad kodning og teknologi kan bruges til “i virkeligheden”, og I får muligheden for at præsentere jeres organisation overfor fremtidens studerende/arbejdskraft. </p>
<h3> Coding Class-forløbet:</h3>
<p><strong>Dag 1. Værktøjskendskab.</strong> Eleverne lærer blokprogrammeringssproget Scratch og tegneprogrammet Piskel at kende. <br>
<strong>Dag 2. Spiludvikling.</strong> Eleverne brainstormer, konceptudvikler, skitserer, planlægger og kommer igang med deres egne spil. <br>
<strong>Dag 3. Arbejd, arbejd.</strong> Eleverne koder, tegner og skaber deres spil. <br>
<strong>Dag 4. Færdiggørelse.</strong> Eleverne færdiggør deres spil, forbereder præsentation og afholder generalprøve for klassen. <br>
<strong>Dag 5. Virksomhedsbesøg.</strong> Eleverne besøger en virksomhed og fremlægger og viser deres spil. <br>
-Virksomhedsbesøget ligger sjældent lige efter Coding Class-forløbet, men aftales individuelt mellem virksomhed og klassens lærer.       </p>

<h3>Hvis I har mod på at være med i projektet, kan I her se hvad det indebærer:</h3> 
<p><strong>•  Matching med skole</strong> <br>
Inden klassens Coding Class-forløb bliver de matchet med jer som virksomhed. <br>
Vi sender en mail til jer og læreren, hvor der står at I er matchet. <br>
I dialog med klassens lærer aftaler I følgende; <br>
Hvor og hvornår virksomhedsbesøget skal foregå. <br> 
Er der projektor til rådighed, hvordan forbinder eleverne, Wi-Fi, og andre praktiske ting. <br> <br>
<strong>•  Virksomhedsbesøg</strong> <br>
I tilrettelægger selv besøgsdagen så den passer til jer, og så eleverne får tid til at præsentere deres spil for jer. <br> <br>
<strong>Et program for dagen f.eks. se således ud:</strong> <br>
<strong>9.00</strong> Eleverne og deres lærer ankommer til jer. <br>
<strong>9.10</strong> I fortæller hvad virksomheden laver og viser dem rundt. <br>
<strong>9.30</strong> En eller flere af medarbejderne fortæller/viser hvad de laver i deres job - måske prøver børnene nogle aktiviteter hos jer. <br>
<strong>10.15</strong> Formiddagspause <br>
<strong>10.30</strong> Eleverne viser deres spil og fortæller om processen, deres egen læring osv. Det tager ca. 5 minutter pr. gruppe. I giver feedback til hver gruppe. <br>
<strong>11.30</strong> Frokost - enten medbringer de selv madpakker, eller også giver I dem noget at spise og drikke. <br>
<strong>12.00</strong> Tak for i dag. <br> <br>
<strong>•  Coding Class Finale</strong> <br>
I inviteres til at deltage i Coding Class finalen i  juni 2023 sammen med alle de deltagende klasser og virksomheder. <br> 
I vil blive takket på sponsorbanner og får adgang til VIP-området for besøgsvirksomheder og andre samarbejdspartnere. </p>

<h3>Vi håber I har lyst til at deltage i Coding Class, og vil være besøgsvirksomhed for én eller flere af byens sjetteklasser i
skoleåret 22/23. </h3>
<h3>Skriv til mefgr@odense.dk hvis I er interesserede.</h3> <br> <br> <br>
  </div>
</template>

<script>
export default {
  name: "virksomhed"
};
</script>



<style scoped>
.no-center p { 
    
    line-height:24px;
}
.no-center  { 
    text-align: left !important; 
    
}
</style>





// WEBPACK FOOTER //
// src/components/pages/virksomhed.vue